import React from 'react';

// Isolates a broken demo to its own canvas instead of white-screening the gallery.
export default class DemoErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className='dsg-demo-error'>
          <b>This demo failed to render.</b>
          <pre>{String(this.state.error && this.state.error.message)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
